import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

import { baseCss } from './css.js';
const buttonBaseCss = baseCss;

const ButtonBaseStyle0 = buttonBaseCss;

const ButtonBase = /*@__PURE__*/ proxyCustomElement(class ButtonBase extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.theme = 'default';
        this.darkMode = false;
        this.titleBtn = 'Open modal';
        this.disabled = false;
    }
    componentDidRender() {
        const svgElement = this.element.querySelector('svg');
        if (svgElement) {
            svgElement.classList.add('flex-shrink-0', 'w-4', 'h-4', 'block');
            svgElement.removeAttribute('style'); // hack frieze svg
        }
    }
    render() {
        return (h("div", { key: '1048576f0a9839c56cac030b1de7899b25b5f39e', class: `theme-${this.theme}` }, h("div", { key: 'ea29f74a1f7e4268802c6e4aaca5867dfd2e4c9b', class: "animate-spin-loading active" }), h("button", { key: '71f84d47b11aa3971818b686f8dddb74e0d36eb0', disabled: this.disabled, type: "button", class: "nl-button py-2.5 px-3 w-full inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg  disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" }, h("slot", { key: '91a91994e20dc10e3bbb2576e4214fa98533be8e', name: "icon-start" }), this.titleBtn)));
    }
    get element() { return this; }
    static get style() { return ButtonBaseStyle0; }
}, [4, "button-base", {
        "theme": [1025],
        "darkMode": [1028, "dark-mode"],
        "titleBtn": [1, "title-btn"],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "button-base":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, ButtonBase);
            }
            break;
    } });
}
defineCustomElement();

export { ButtonBase as B, defineCustomElement as d };

//# sourceMappingURL=button-base2.js.map